module.exports = __webpack_public_path__ + "img/ad-printcamp.3ca90031.jpeg";